/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spellcheck_Loading_LabelInputs */



/**
* | output |
* | --- |
* | "Loading indicator" |
*
* @param {Spellcheck_Loading_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const spellcheck_loading_label = /** @type {((inputs?: Spellcheck_Loading_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spellcheck_Loading_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Indicateur de chargement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ladeanzeige")
	if (locale === "it") return /** @type {LocalizedString} */ ("Indicatore di caricamento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Индикатор загрузки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Indicador de carga")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("加载指示器")
	if (locale === "ja") return /** @type {LocalizedString} */ ("読み込みインジケーター")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लोडिंग संकेतक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Indicador de carregamento")
	return /** @type {LocalizedString} */ ("Loading indicator")
});